import React, { useContext, useEffect, useState } from "react";
import { BuilderContext, useDrawer } from "react-flow-builder";
import { Form, Button, Input, Select, Modal, message } from "antd";
import { store } from "../../../../../../../redux";
import { setDraft } from "../../../../../../../redux/actions/skill";
import { notify } from "../../../../../../../redux/actions/snackActions";
import captureXpathIcon from "../../../../../../../images/capture-xpath.png";
import { v4 as uuid } from "uuid";
import moment from "moment";
import TextField from "@material-ui/core/TextField";
import { useDispatch, useSelector } from "react-redux";
import CodeEditor from "@uiw/react-textarea-code-editor";
import info from "../../../../../../../images/info.png";
import sampleData from "../../sampleData.json"
import CopyToClipboard from "react-copy-to-clipboard";
import { CopyOutlined } from "@ant-design/icons";

const { TextArea } = Input;

const { Option } = Select;

const XmlToJsonConfig = () => {
  const dispatch = useDispatch();
  let { selectedNode: node, flowVariables, nodes } = useContext(BuilderContext);
  const { closeDrawer: cancel } = useDrawer();
  const [nodeData, setNodeData] = useState(null);
  const [selectType, setSelectType] = useState("select");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [codeContent, setCodeContent] = useState('');
  const [xmlText, setXmlText] = useState('');
  const [copySuccess, setCopySuccess] = useState(false);
  const [form] = Form.useForm();

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const success = () => {
    message.success('Copied to clipboard');
  };

  useEffect(() => {
    // Fetch the data from sampleData using the key "GET_OUTLOOK_MAIL"
    const data = sampleData[12]["XML_FILEPATH"].data;
    const data1 = sampleData[13]["XML_TEXT"].data;

    const codeContent = JSON.stringify(data, null, 2);
    const xmlContent = JSON.stringify(data1, null, 2);
    // Get the examples
    const codeExample = sampleData[12]["XML_FILEPATH"].Example;
    const xmlExample = sampleData[13]["XML_TEXT"].Example;

    const headerContent = "Output variable to capture the response.\nBelow is the sample response."

    // Set the content to the state variables along with examples
    const fullContent = `${headerContent}\n\n${codeContent}\n\n${codeExample}`;
    const fullFolderContent = `${headerContent}\n\n${xmlContent}\n\n${xmlExample}`;
    setCodeContent(fullContent);
    setXmlText(fullFolderContent);
  }, []);

  const findAndUpdate = (arr, id, payload) => {
    let found = arr.findIndex((i) => i.id == id);
    if (found > -1) {
      arr[found] = { ...arr[found], ...payload };
    } else {
      arr.forEach((element) => {
        if (
          [
            "branch",
            "condition",
            "loop",
            "loop-nodes",
            "try",
            "try-catch-node",
            "review",
            "review-node",
          ].includes(element.type)
        ) {
          findAndUpdate(element.children, id, payload);
        }
      });
    }
    return arr;
  };

  const validateVariableName = (variable) => {
    if (variable && variable.includes("-") || variable.includes(' ')) {
      return false;
    }
    return true;
  };

  const newVariables = useSelector((state=> state.skillReducer?.trainDraft?.RAW_DATA?.variables))

  const checkForDuplicateVariable = (userVariable) => {
    
    const variableExists = newVariables?.some((variable) => variable.id !== nodeData.id && variable.name === userVariable);
    if (variableExists) {
      dispatch(
        notify(
          "error",
          "Duplicate variable names are not allowed."
        )
      );
      return false;
    }
    return true;
  };

  const handleSubmit = async (validate) => {
    try {
      let values;
      if (selectType === "" || selectType === "select") {
        dispatch(
          notify(
            "error",
            "Please select operation."
          )
        );
        return;
      }
      if (validate === false) {
        values = form.getFieldsValue();
      } else {
        values = await form.validateFields();
        if (values.jsonVariable == null) {
        } else if (!validateVariableName(values.jsonVariable)) {
          dispatch(
            notify(
              "error",
              "Invalid variable name. The use of '-' symbol and spaces are not allowed in variable names."
            )
          );
          return;
        };
        if (values.xmlVarName == null) {
        } else if (!validateVariableName(values.xmlVarName)) {
          dispatch(
            notify(
              "error",
              "Invalid variable name. The use of '-' symbol and spaces are not allowed in variable names."
            )
          );
          return;
        } 
      }
     
      let {
        skillReducer: { trainDraft },
      } = store.getState();
      console.log(values, "val");

      let obj = {};
      store.getState();

      obj.xmlFilePath = values?.xmlFilePath || "";
      const userVariable = values.jsonVariable;
       if (!checkForDuplicateVariable(userVariable)) {
          return;
        }
      obj.jsonVariable = values?.jsonVariable || "";
      obj.xmlText = values?.xmlText || "";
      const userVariable1 = values.xmlVarName;
      if (!checkForDuplicateVariable(userVariable1)) {
        return;
      }
      obj.xmlVarName = values?.xmlVarName || "";

      obj.selectType = selectType;
      nodes = nodes.filter((i) => !(i.isStart || i.isEnd));
      let newActions = findAndUpdate(nodes, nodeData.id, obj);
      store.dispatch(
        setDraft({
          ...trainDraft,
          RAW_DATA: { ...trainDraft.RAW_DATA, actions: newActions },
        })
      );

      if (validate === true) cancel();
    } catch (error) {
      console.log("form error: ", error.toString());
    }
  };

  const handleTypeChange = (e) => {
    setSelectType(e.target.value);
  };

  const renderActionFields = (type) => {
    switch (type) {
      case "xmlfilePath":
        return (
          <div>
            <Form.Item
              name="xmlFilePath"
              label="File Path (Include file name with extension)"
              rules={[{ required: true }]}
              help="Eg: C:\Users\text.xml"
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="jsonVariable"
              label="Variable to capture JSON content"
              rules={[{ required: true }]}
              help="Eg: variableName"
            >
              <Input />
            </Form.Item>
            <div style={{ position: 'relative' }}>
              <div className="ip-tl-label" style={{
                position: "absolute",
                display: "inline-block",
                margin: "0",
                top: "-91px",
                left: "192px"
              }}>
                <a
                  className="tlt-icon tl-tooltip task-table-info"
                  href="javascript:void(0)"
                  onClick={showModal}
                >
                  <img src={info} alt="" />
                </a>
              </div>
            </div>

            <Modal
              title="Reference"
              className="scrollable-modal"
              visible={isModalOpen}
              onCancel={handleCancel}
              footer={null}
              style={{
                top: 20,
              }}
            >
              <CodeEditor value={codeContent} />
              <div style={{ position: 'absolute', top: 10, right: 50 }}>
                <CopyToClipboard text={codeContent} onCopy={() => setCopySuccess(true)}>
                  <Button onClick={success} type="primary" icon={<CopyOutlined />}>
                    Copy
                  </Button>
                </CopyToClipboard>
              </div>
            </Modal>
          </div>
        );

      case "xmlText":
        return (
          <div>
            <Form.Item
              name="xmlText"
              label="Paste your XML Content here"
              rules={[{ required: true }]}
              help="Eg: <root><person><name>John Doe</name></person></root>"
            >
              <TextArea placeholder="Enter your XML content" rows={4} />
            </Form.Item>
            <Form.Item
              name="jsonVariable"
              label="Variable to capture JSON content"
              rules={[{ required: true }]}
              help="Eg: variableName"
            >
              <Input />
            </Form.Item>
            <div style={{ position: 'relative' }}>
              <div className="ip-tl-label" style={{
                position: "absolute",
                display: "inline-block",
                margin: "0",
                top: "-91px",
                left: "192px"
              }}>
                <a
                  className="tlt-icon tl-tooltip task-table-info"
                  href="javascript:void(0)"
                  onClick={showModal}
                >
                  <img src={info} alt="" />
                </a>
              </div>
            </div>

            <Modal
              title="Reference"
              className="scrollable-modal"
              visible={isModalOpen}
              onCancel={handleCancel}
              footer={null}
              style={{
                top: 20,
              }}
            >
              <CodeEditor value={xmlText} />
              <div style={{ position: 'absolute', top: 10, right: 50 }}>
                <CopyToClipboard text={xmlText} onCopy={() => setCopySuccess(true)}>
                  <Button onClick={success} type="primary" icon={<CopyOutlined />}>
                    Copy
                  </Button>
                </CopyToClipboard>
              </div>
            </Modal>
          </div>
        );

      case "xmlVarName":
        return (
          <div>
            <Form.Item
              name="xmlVarName"
              label="Variable name containg XML data or file path"
              rules={[{ required: true }]}
              help="Eg: `variableName`"
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="jsonVariable"
              label="Variable to capture JSON content"
              rules={[{ required: true }]}
              help="Eg: variableName"
            >
              <Input />
            </Form.Item>
            <div style={{ position: 'relative' }}>
              <div className="ip-tl-label" style={{
                position: "absolute",
                display: "inline-block",
                margin: "0",
                top: "-91px",
                left: "192px"
              }}>
                <a
                  className="tlt-icon tl-tooltip task-table-info"
                  href="javascript:void(0)"
                  onClick={showModal}
                >
                  <img src={info} alt="" />
                </a>
              </div>
            </div>

            <Modal
              title="Reference"
              className="scrollable-modal"
              visible={isModalOpen}
              onCancel={handleCancel}
              footer={null}
              style={{
                top: 20,
              }}
            >
              <CodeEditor value={xmlText} />
              <div style={{ position: 'absolute', top: 10, right: 50 }}>
                <CopyToClipboard text={xmlText} onCopy={() => setCopySuccess(true)}>
                  <Button onClick={success} type="primary" icon={<CopyOutlined />}>
                    Copy
                  </Button>
                </CopyToClipboard>
              </div>
            </Modal>
          </div>
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    setNodeData(node);
    setSelectType(node.selectType);
  }, [node]);
  const onChange = (allFields) => {
    handleSubmit(false);
  };

  return (
    <div>
      {nodeData ? (
        <div>
          <Form
            className=""
            form={form}
            initialValues={nodeData}
            onValuesChange={(_, allFields) => {
              onChange(allFields);
            }}
          >
            <div className="ant-row ant-form-item">
              <label className="ant-form-item-required">
                Select Operation
              </label>
              <div className="ant-col ant-form-item-control">
                <select
                  className="ant-input"
                  style={{ padding: "10px" }}
                  value={selectType}
                  onChange={(e) => handleTypeChange(e)}
                >
                  <option value="select">Select</option>
                  <option value="xmlfilePath">XML File Path</option>
                  <option value="xmlText">XML Text</option>
                  <option value="xmlVarName">XML Variable</option>
                </select>
              </div>
            </div>

            {renderActionFields(selectType)}
          </Form>

          <div>
            <Button onClick={cancel}> Cancel </Button>
            <Button
              type="primary"
              onClick={() => {
                handleSubmit(true);
              }}
            >
              Save
            </Button>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default XmlToJsonConfig;
